import { render, staticRenderFns } from "./SampleRequestList.vue?vue&type=template&id=ae55f512&scoped=true"
import script from "./SampleRequestList.vue?vue&type=script&lang=js"
export * from "./SampleRequestList.vue?vue&type=script&lang=js"
import style0 from "./SampleRequestList.vue?vue&type=style&index=0&id=ae55f512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae55f512",
  null
  
)

export default component.exports